export class Action {
    constructor(public alias: string) {

    }
}
